import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

// Components
import BaseTemplate from "./BaseTemplate";
import Text from "new_components/atoms/Text";
import ImageButton from "new_components/molecules/ImageButton";
import AILogo from "new_components/molecules/AILogo";

// Constants
import colors from "styles/colors";
import typography, { applyTypography } from "styles/typography";
import { ICON_SET } from "new_components/atoms/Icon/IconSet";

// Wrapper for the action row
const ActionRow = styled.div`
  display: ${({ show }) => (show ? "flex" : "none")};
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 16px;
`;

const DescriptionSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 16px;
  max-width: 500px;
  margin-bottom: 20px;
`;

// Centered Content Wrapper
const CenteredContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  font-family: "Raleway";
  align-items: center;
  justify-content: center;

  height: 90vh;
`;

const DescriptionText = styled(Text)`
  ${applyTypography(typography.body.regular)}
  line-height: 1.6;
`;

const CompanyLogoSection = styled.div`
  margin-bottom: 40px;
`;

// Middle Heading Section
const BottomAction = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 20px;
`;

const ZeroStateTemplate = ({
  backAction,
  backButtonText = "Back",
  actionRowComponent,
  titleText,
  gradientText,
  postGradientText,
  gradientColor = colors.gradients.blueGreen,
  descriptionText,
  descriptionText2,
  ctaRow,
}) => {
  return (
    <BaseTemplate scrollable={false}>
      <CenteredContentWrapper>
        {/* Action Row */}
        <ActionRow show={backAction || actionRowComponent}>
          {backAction && (
            <ImageButton
              text={backButtonText}
              textStyle={true}
              icon={ICON_SET.chevronLeft}
              onClick={backAction}
              color={colors.text.gray}
            />
          )}
          {actionRowComponent}
        </ActionRow>
        <CompanyLogoSection>
          <AILogo />
        </CompanyLogoSection>
        {/* Middle Heading */}
        <Text typographyStyle={typography.zeroState.regular}>
          {titleText}{" "}
          <Text
            typographyStyle={typography.zeroState.bold}
            gradient={gradientColor}
          >
            {gradientText}
          </Text>
          {postGradientText && ` ${postGradientText}`}
        </Text>

        <DescriptionSection>
          {/* Description Text */}
          <DescriptionText
            typographyStyle={typography.body.regular}
            color={colors.text.black}
          >
            {descriptionText}
          </DescriptionText>
          {descriptionText2 && (
            <DescriptionText
              typographyStyle={typography.body.regular}
              color={colors.text.black}
            >
              {descriptionText2}
            </DescriptionText>
          )}
        </DescriptionSection>

        {/* CTA Row */}
        <BottomAction>{ctaRow}</BottomAction>
      </CenteredContentWrapper>
    </BaseTemplate>
  );
};

ZeroStateTemplate.propTypes = {
  children: PropTypes.node, // Content passed into the layout
  heading: PropTypes.string, // Heading text for the base layout
  pageTitle: PropTypes.string, // Page title for the base layout
  middleHeading: PropTypes.string, // Middle heading text
  middleSubtitle: PropTypes.string, // Middle subtitle text
  scrollable: PropTypes.bool, // Whether the layout should handle scrolling
};

ZeroStateTemplate.defaultProps = {
  scrollable: true, // Default to scrollable
};

export default ZeroStateTemplate;
